/** Account branding is presentation only; permissions always use role and ownership. */
export type BrandAccount = { brand?: string | null; username?: string | null };

export function getAccountBrand(account?: BrandAccount | null): string {
  const explicit = account?.brand?.trim().toLowerCase();
  if (explicit) return explicit;
  // Preserve established DealNet accounts that predate the brand column.
  if (account?.username === "dealnet" || account?.username === "SuperDealNet") return "dealnet";
  return "gewgul";
}

export function getBrandLoginPath(account?: BrandAccount | null): string {
  const brand = getAccountBrand(account);
  return ["roadmover", "dealnet", "liquornet", "gofishingnet"].includes(brand)
    ? `/login/${brand}`
    : "/auth";
}
